import { createContext } from "react";
import { Participant } from "twilio-video";

type SelectedParticipant = [Participant, (participant?: Participant) => void];

export const SelectedParticipantContext = createContext<SelectedParticipant>(
  null!,
);
